<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
    <div class="container-fluid">
      <!--<a class="navbar-brand fw-bold text-white custom-margin" href="#">GESTIONALE PARERI</a>-->

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
              aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-between" id="navbarNav">

        <!--<Navbar 
          :current-view="currentView" 
          :user-permissions="userPermissions"
          @change-view="$emit('change-view', $event)"
        />-->
        <div></div>

        <!-- Sezione destra -->
        <div class="d-flex align-items-center">
          <div class="dropdown me-2" v-if="$root.user"> 
            <button class="btn btn-link text-white dropdown-toggle text-decoration-none" type="button"
                    data-bs-toggle="dropdown">
              <i class="bi bi-person-circle"></i> {{ $root.user.name }} 
            </button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="dropdown-item" @click="$emit('change-view', 'ProfileView')">Profilo</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item text-danger" @click="$emit('logout')">Logout</a></li>
            </ul>
          </div>

          <!--<div class="btn">
            <button class="btn text-light" type="button" @click="$root.toggleDarkMode()">
              <i class="bi" :class="!$root.darkmode ? 'bi-sun-fill' : 'bi-moon-fill'"></i>
            </button>
          </div>-->
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Navbar from './Navbar.vue';

export default {
  name: 'HeaderTemplate',
  components: { Navbar },
  props: {
    currentView: {
      type: String,
      required: true
    }
  },
  computed: {
    userPermissions() {
      return this.$root.user?.permissions || [];
    }
  },
  emits: ['change-view', 'logout']
};
</script>

<style scoped>
.custom-margin {
  margin-right: 7rem;
}

.bg-primary {
    --bs-bg-opacity: 1 !important;
    background-color:  #0A2342 !important;
    height: 3rem !important;
}

nav.navbar {
  position: fixed;
  top: 0;
  z-index: 1020; 
  width: 100%;
}


</style>
